import { ExtractedPlant, ExtractedSite } from './summarySitePlantUtils';

export const applySiteSelection = (
  siteId: string,
  extractedSites: ExtractedSite[],
  selectedCustomerId: string
): { siteId: string; customerId: string } => {
  if (!siteId) {
    return { siteId: '', customerId: selectedCustomerId };
  }
  const selectedSite = extractedSites.find((s) => s.siteId === siteId);
  if (!selectedSite) {
    return { siteId, customerId: selectedCustomerId };
  }
  const customerId =
    !selectedCustomerId || selectedCustomerId !== selectedSite.customerId
      ? selectedSite.customerId
      : selectedCustomerId;
  return { siteId, customerId };
};

export const applyPlantSelection = (
  plantId: string,
  extractedPlants: ExtractedPlant[],
  selectedCustomerId: string,
  selectedSiteId: string
): { plantId: string; customerId: string; siteId: string } => {
  if (!plantId) {
    return { plantId: '', customerId: selectedCustomerId, siteId: selectedSiteId };
  }
  const selectedPlant = extractedPlants.find((p) => p.plantId === plantId);
  if (!selectedPlant) {
    return { plantId, customerId: selectedCustomerId, siteId: selectedSiteId };
  }
  const customerId =
    !selectedCustomerId || selectedCustomerId !== selectedPlant.customerId
      ? selectedPlant.customerId
      : selectedCustomerId;
  const siteId =
    !selectedSiteId || selectedSiteId !== selectedPlant.siteId
      ? selectedPlant.siteId
      : selectedSiteId;
  return { plantId, customerId, siteId };
};
